import './LegalContent.scss';

class LegalContent {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['LegalContent'] = LegalContent;
export default LegalContent;
